module.exports = new __parcel__URL__("chat-darkmode.d567d134.svg").toString();